import styled from '@emotion/styled';

export const ModalContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: max-content;
  position: relative;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const PageTitle = styled.h1`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  line-height: 31.2px;
  font-weight: 700;
  margin: 0;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AutoSaveIcon = styled.div`
  width: 24px;
  height: 24px;
  
  &::before {
    content: '💾';
    font-size: 20px;
  }
`;

export const AutoSaveText = styled.span`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
`;

export const SettingsButton = styled.button`
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &::before {
    content: '⚙️';
    font-size: 20px;
  }
`;

export const MappingContainer = styled.div`
  width: 100%;
  border: 1px solid #dddddd;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
  position: relative;
`;

export const MappingHeader = styled.div`
  display: flex;
  border-bottom: 1px solid #dddddd;
  position: relative;
`;

export const LeftHeader = styled.div`
  width: 50%;
  height: 57px;
  border-right: 1px solid #dddddd;
  display: flex;
  align-items: center;
  padding: 0 16px;
`;

export const RightHeader = styled.div`
  width: 50%;
  height: 57px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #dddddd;
`;

export const RightHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SectionTitle = styled.h3`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  line-height: 25px;
  font-weight: 500;
  margin: 0;
`;

export const LockButton = styled.button`
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  
  ${({ isLocked }) => `
    color: ${isLocked ? '#CF1919' : '#666666'};
    opacity: ${isLocked ? 1 : 0.7};
  `}
  
  &:hover {
    opacity: 1;
  }
`;

export const MatchInfo = styled.div`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  white-space: nowrap;
`;

export const MappingContent = styled.div`
  display: flex;
  min-height: 400px;
  position: relative;
`;

export const LeftColumn = styled.div`
  width: 50%;
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-right: 1px solid #dddddd;
`;

export const RightColumn = styled.div`
  width: 50%;
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FilterSection = styled.div`
  display: flex;
  gap: 20px;
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 8px;
`;

export const FilterCheckbox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  border-radius: 2px;
  background: #ffffff;
  border: 1px solid #767676;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:checked {
    background: #6A42F2;
    border-color: #6A42F2;
  }
  
  &:focus {
    outline: 2px solid rgba(106, 66, 242, 0.3);
    outline-offset: 2px;
  }
`;

export const FilterLabel = styled.label`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  cursor: pointer;
`;

export const VariableList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MappingArrow = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 24px;
  height: 24px;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #666666;
  z-index: 10;
`;

export const VariableCard = styled.div`
  min-height: 35px;
  border-radius: 6px;
  border: 1px solid #dddddd;
  padding: 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  
  ${({ type, status }) => {
    if (type === 'existing') {
      return `background: #f9fafb;`;
    } else {
      switch (status) {
        case 'matched':
          return `background: #eeeeee;`;
        case 'similar':
          return `background: #eeeeee;`;
        case 'error':
          return `background: rgba(255, 75, 75, 0.08);`;
        case 'unmatched':
          return `background: #eeeeee;`;
        default:
          return `background: #eeeeee;`;
      }
    }
  }}
`;

export const VariableName = styled.span`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 17px;
  font-weight: ${({ fontWeight }) => fontWeight || 400};
  flex: 1;
`;

export const StatusIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatusIcon = styled.div`
  width: 28px;
  height: 26px;
  border-radius: 50%;
  background: ${({ color }) => color || '#666666'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
`;

export const ErrorText = styled.span`
  color: #CF1919;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  line-height: 24px;
  font-weight: 400;
`;

export const PendingCard = styled.div`
  min-height: 37px;
  border-radius: 6px;
  border: 1px solid #dddddd;
  background: rgba(252, 255, 75, 0.3);
  padding: 10px;
  display: flex;
  align-items: center;
`;

export const PendingText = styled.div`
  color: #009444;
  font-family: "Inter", sans-serif;
  font-style: italic;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
`;

export const ActionButtons = styled.div`
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 16px;
`;

export const ActionButton = styled.button`
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  
  &:first-of-type::before {
    content: '↑';
    font-size: 18px;
    color: #666666;
  }
  
  &:last-of-type::before {
    content: '↓';
    font-size: 18px;
    color: #666666;
  }
  
  &:hover {
    opacity: 0.7;
  }
`;



